// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3iuRh","colMin":"styles_colMin__1Ozlt","colCheckbox":"styles_colCheckbox__39nMv"};